<div class="banner-section"
     *ngIf="announcements?.length"
     [ngClass]="{
        'banner-section--bottom': bottomAligned,
        'banner-section--offset-bottom': bottomTrayEnabled,
        'banner-section--bottom-desktop': desktopBottomAligned
     }">
    <div class="banner-background ms-bgc-tp">
        <ohp-announcement *ngFor="let announcement of announcements; trackBy: trackByIndex" [announcement]="announcement"></ohp-announcement>
    </div>
</div>
